import { path } from 'ramda';

export const basicPieParser = (chartData) => {
  const serie = path(['series', 0])(chartData);

  chartData.serie = serie;
  chartData.label = chartData.axis;
};
